// Timer
setInterval(function time() {
  var currentDate = new Date();
  var d = new Date(new Date().getTime() + 168 * 60 * 60 * 1000);
  const diffTime = Math.abs(d - currentDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  var hours = 24 - d.getHours();
  var min = 60 - d.getMinutes();
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  var sec = 60 - d.getSeconds();
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }
  $(".timer").html(hours + ":" + min + ":" + sec + "");
}, 1000);

var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateNew = new Date(new Date().getTime() + 168 * 60 * 60 * 1000);
var day = currentDateNew.getDate();
let dayN = "th";
switch (day) {
  case 1:
    dayN = "st";
    break;
  case 2:
    dayN = "nd";
    break;
  case 3:
    dayN = "rd";
    break;
  default:
    dayN = "th";
}
var month = currentDate.getMonth() + 1;
var year = currentDate.getFullYear();
var days = [
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];
const monthNames = [
  "Jan",
  "Fév",
  "Mar",
  "Avr",
  "Peut",
  "Juin",
  "Juillet",
  "Août",
  "Sep",
  "Octobre",
  "Nov",
  "Déc",
 ];
$(".date-product").html(
  days[currentDateNew.getDay()] +
    ", " +
    day +
    " " +
    monthNames[currentDateNew.getMonth()]
);
// Timer End

// Product Form
$(".eam-warranty-right-button p").click(function () {
  $(".product-add-to-cart-container")[0].scrollIntoView();
});

// Black PDP

// if(typeof enable_slider != 'undefined' && enable_slider){
//    if(window.outerWidth > 786) {
//        const slider = new Flickity('.eam-five-reasons-content-slick');
//         slider.destroy();
//     }
// }
$(document).on("click", ".add-to-cart-bottom", function () {
  $(".tooltip-bottom__div").slideToggle();
});

// if(window.outerWidth > 786) {
//   $(document).on("click","body",function(event) {
//     if($(".tooltip-bottom__div").css('display') != 'none'){
//       if($(event.target).hasClass('add-to-cart-bottom')){
//         return;
//       }else{
//         $(".tooltip-bottom__div").slideToggle();
//       }
//     }
//   });
// }

// document.addEventListener("click", function(event) {
//   var target = evzent.target;
//   var accordionSummaries = document.querySelectorAll(".shopify-section.custom-faq .collapsible-content .accordion details summary");

//   if (target.matches(".shopify-section.custom-faq .collapsible-content .accordion details summary")) {
//     for (var i = 0; i < accordionSummaries.length; i++) {
//       var detailsElement = accordionSummaries[i].parentNode;
//       detailsElement.setAttribute("open");
//     }
//   }
// });

$(document).ready(function () {
  // (Optional) Active an item if it has the class "is-active"
  $(".faqs .accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown("fast");
  $(".faqs .accordion .accordion-thumb").click(function () {
    // Cancel the siblings
    $(this)
      .toggleClass("is-active-thumb")
      .closest(".accordion-item")
      .toggleClass("is-active")
      .find(".accordion-panel")
      .slideToggle("fast");
    $(this).find(".icon").toggleClass("rotate--icons");
    // Toggle the item
    //$(this).closest(".accordion-item").toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});

$(".product__accordion-main__js .details-tab > summary").click(function () {
  let $this = $(this);
  $this.next().slideToggle("fast");
  $this.parent().toggleClass("details-tab__open");
});

$(document).ready(function () {
  // Define the CSS rules
  var cssCode =
    ".product-grid-container .flickity-slider { transition: all 0.1s; }";
  // Create a <style> element and append it to the <body> tag
  $("<style>").prop("type", "text/css").html(cssCode).appendTo("body");

  if ($(".pillar-box-columns").length) {
    $(".pillar-box-columns").flickity({
      cellAlign: "left",
      contain: true,
      pageDots: true,
      ImagesLoaded: true,
      prevNextButtons: false,
      watchCSS: true,
    });
  }

  if ($(".static-slider").length) {
    $(".static-slider").flickity({
      cellAlign: "center",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      groupCells: true
    });
  }
  if($(".accordion-image").length){
    $(".accordion-image").flickity({
      cellAlign: "center",
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      groupCells: true,
      setGallerySize: false
    });
  }
  $(document).on("click", ".accordion-title", function () {
    const $parent = $(this).parent();
    const index = $parent.index() + 1;
    $parent.parent().find(".accordion-item").not($parent).removeClass("active");
    $parent.parent().find(".accordion-content").css("height", 0);
    $parent.parents('.accordion-list').find('.accordion-image').removeClass('active');
    $parent.parents('.accordion-list').find('.accordion-image').addClass('hidden');
    $parent.parents('.accordion-list').find(`.accordion-image[data-index="${index}"]`).removeClass('hidden');
    $parent.toggleClass("active");
    if($parent.hasClass("active")){
      const totalHeight = $(this).next().find(".content-wrapper").outerHeight();
      $(this).next().css("height", totalHeight);
    }else{
      $(this).next().css("height", 0);
    }
  });
  if ($(".accordion-item").length) {
    $(".accordion-item").each(function () {
      const index = $(this).index() + 1;
      if ($(this).hasClass("active")) {
        $(this).parents(".accordion-list").find(`.accordion-image[data-index="${index}"]`).removeClass('hidden');
        $(this)
          .find(".accordion-content")
          .css("height", $(this).find(".content-wrapper").outerHeight());
      } else {
        $(this).parents(".accordion-list").find(`.accordion-image[data-index="${index}"]`).addClass('hidden');
        $(this).find(".accordion-content").css("height", 0);
      }
    });
  }
  $(document).on("click", ".in-this-article.mobile-only > p", function () {
    const content = $(this).next();
    const contentHeight = content.find('ul').outerHeight();
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      content.css("height", contentHeight);
    } else {
      content.css("height", 0);
    }
  });
});

//Only use when have dropdown
/*
function adjustoutofstockVariant(){
let option_1 = document.querySelector('.product-information .product-form__input--dropdown select').value;
let color_option_selected = document.querySelector('.product-information .product-form__input--color input:checked').value;
let color=0;
for(let i=0;i<document.querySelector('.product-information .product-form__input').length;i++){
  if(document.querySelector('.product-information .product-form__input')[i].classList.contains('product-form__input--color')){
    color = i;
    break;
  }
}

// Disable all color option
for(let p = 0;p<document.querySelectorAll('.product-information .product-form__input--dropdown select option').length;p++){
  document.querySelectorAll('.product-information .product-form__input--dropdown select option')[p].classList.add('eam-option-disabled');
}
for(let p = 0;p<document.querySelectorAll('.product-information .variant-container label').length;p++){
  document.querySelectorAll('.product-information .variant-container label')[p].classList.add('eam-option-disabled');
}
// Enable them based on availablity
for(let j=0;j<all_variants.length;j++){
  let current_variant = all_variants[j];
  for(let k=0;k<document.querySelectorAll('.product-information .variant-container input').length;k++){
    let current_color_option = document.querySelectorAll('.product-information .variant-container input')[k].value,current_title;
    if(color == 0){
      current_title = current_color_option +' / '+option_1;
    }else if(color == 1){
      current_title = option_1 + ' / '+current_color_option;
    }
    if(all_variants[j].title==current_title){
      document.querySelectorAll('.product-information .variant-container label')[k].classList.remove('eam-option-disabled');
    }
  }
}

 for(let j=0;j<all_variants.length;j++){
  let current_variant = all_variants[j];
  for(let k=0;k<document.querySelectorAll('.product-information .product-form__input--dropdown select option').length;k++){
    let current_other_option = document.querySelectorAll('.product-information .product-form__input--dropdown select option')[k].value,current_title;
    if(color == 0){
      current_title = color_option_selected + ' / '+current_other_option;
    }else if(color == 1){
      current_title = current_other_option +' / '+color_option_selected;
    }
    if(all_variants[j].title==current_title){
      document.querySelectorAll('.product-information .product-form__input--dropdown select option')[k].classList.remove('eam-option-disabled');
    }
  }
}
}
$(document).ready(function(){
adjustoutofstockVariant();
});
*/

function handleOpenedAccordion() {
  if ($(".accordion-group").length) {
    $(".accordion-group").each(function () {
      if ($(this).hasClass("active")) {
        $(this)
          .find(".accordion-group__content")
          .css("height", $(this).find(".content-inner").outerHeight());
      } else {
        $(this).find(".accordion-group__content").css("height", 0);
      }
    });
  }
}
handleOpenedAccordion();
$(window).on("resize", function () {
  handleOpenedAccordion();
});
$(document).on("click", ".accordion-group__title", function () {
  const parent = $(this).parent();
  parent.toggleClass("active");
  if (parent.hasClass("active")) {
    $(this)
      .next()
      .css("height", $(this).next().find(".content-inner").outerHeight());
  } else {
    $(this).next().css("height", 0);
  }
  if ($(this).parents(".single-open").length) {
    parent.siblings().removeClass("active");
    parent.siblings().find(".accordion-group__content").css("height", 0);
  }
});
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/*
$(document).on("click", ".cart-drawer-footer .checkout", function (e) {
  e.preventDefault();
  const promises = [];
  let url = "";
  $(".product-cart-item").each(function () {
    const qty = $(this).data("qty");
    const title = $(this).data("title");
    const eu = `${$(this).data("eu")}.json`;
    $('#Cart-Drawer').addClass('loading');  
    promises.push(fetch(eu)
      .then((response) => response.json())
      .then((data) => {
        const variants = data.product.variants;
        variants.forEach((variant) => {
          console.log(variant.title, title);
          if (variant.title === title) {
            const variantID = variant.id;
            url += `${variantID}:${qty},`;
          }
        });
      })
    );
    Promise.all(promises).then(() => {
      const discount_code = getCookie('discount_code');
      let full_url;
      if(discount_code){
        full_url = `https://eu.laifentech.com/cart/${url}?locale=de&discount=${discount_code}`;
      }else{
        full_url = `https://eu.laifentech.com/cart/${url}?locale=de`;
      }
      window.location.href = full_url;
    });
  });
});
*/


$(document).ready(function() {
  // 1. On click of label, add input and hide label
  $(document).on('click', '.rebuy-cart__flyout-item-quantity-widget-label', function() {
      const $label = $(this);
      const value = $label.contents().filter(function() {
        return this.nodeType === 3; // Only get text nodes
      }).text().trim();
      
      $label.addClass('hide');
      $label.after(`<input type="number" class="rebuy-quantity-input" value="${value}" />`);
      $('.rebuy-quantity-input').focus();
  });

  function updateRebuyQty($input) {
    if($input) {
      const value = $input.val().trim();
      const $label = $input.prev('.rebuy-cart__flyout-item-quantity-widget-label');
      if (value > 0) {
      
        $label.text(value);

        const parentEl = $input.parents('.rebuy-cart__flyout-item');
        const cartObject = window.Rebuy.Cart;
        const item = cartObject.cart.items[parentEl.index()];
        parentEl.addClass('disabled');
        cartObject.setItemQuantity(item, value, function(){
          parentEl.removeClass('disabled');
        });
      }
      $label.removeClass('hide'); 
      $input.remove();
    }
  }

  $(document).on('keyup', '.rebuy-quantity-input', function(e) {
    if (e.keyCode === 13) { // Enter key code
        updateRebuyQty($(this));
    }
  });

  $(document).on('blur', '.rebuy-quantity-input', function() {
    setTimeout(() => updateRebuyQty($(this)), 10);
  });
});